@if (commentBannersService.currentBanner$ | async; as banner) {
  <div
    class="comment-panel-banner"
    [style.background-color]="banner.bgColor"
    [attr.data-cy]="banner.id">
    <div class="banner-content" role="alert" aria-live="polite">
      <i [class]="banner.icon"></i>
      <span class="banner-message" [translate]="banner.message"></span>
      @if (banner.actionCallback && banner.actionText) {
        <a
          class="action-button"
          (click)="banner.actionCallback()"
          [attr.aria-label]="banner.actionText | translate"
          [translate]="banner.actionText">
        </a>
      }
    </div>
    @if (banner.showSpinner) {
      <i class="ficon-spinner ficon-spin"></i>
    }
    @if (banner.closeable) {
      <button
        class="close"
        [attr.aria-label]="'common_close' | translate"
        (click)="closeBanner(banner.id)">
        <i class="ficon-app-x"></i>
      </button>
    }
  </div>
}
